import axios from 'axios';
import authHeader from "@/service/auth-header";

class AlertComponentService {

    async getAlertComponentsForAlert(alertId) {
        return await axios.get(`/api/applications/si/alertcomponent/${alertId}`,{ headers: authHeader() })
    }

    async createAlertComponent(alertId, data) {
        console.log('[AlertComponentService][createAlertComponent] data = ', data);
        return await axios.post(`/api/applications/si/alertcomponent/${alertId}`, data,{ headers: authHeader() });
    }

    async updateAlertComponent(id, data) {
        return await axios.put(`/api/applications/si/alertcomponent/${id}`, data,{ headers: authHeader() });
    }

    async deleteAlertComponent(id) {
        return await axios.delete(`/api/applications/si/alertcomponent/${id}`,{ headers: authHeader() })
    }

}

export default new AlertComponentService();
